import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { FailedPrintJob } from '../types';

interface FailedPrintJobsStore {
    jobs: Record<string, FailedPrintJob>;
    addFailedJob: (job: FailedPrintJob) => void;
    removeFailedJob: (cartId: string) => void;
}

export const useFailedPrintJobsStore = create(
    persist<FailedPrintJobsStore>(
        (set) => ({
            jobs: {},
            addFailedJob: (job) =>
                set((state) => ({
                    jobs: { ...state.jobs, [job.cartId]: job },
                })),
            removeFailedJob: (cartId) =>
                set((state) => {
                    const jobs = { ...state.jobs };
                    delete jobs[cartId];

                    return { jobs };
                }),
        }),
        {
            name: 'failed-print-jobs-store',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);

export function useFailedPrintJob(
    cartId: string | undefined,
): FailedPrintJob | undefined {
    return useFailedPrintJobsStore((state) =>
        cartId ? state.jobs[cartId] : undefined,
    );
}

export function useHasFailedPrintJob(cartId: string | undefined): boolean {
    return useFailedPrintJobsStore((state) =>
        cartId ? !!state.jobs[cartId] : false,
    );
}
